// extracted by mini-css-extract-plugin
export var bookImage = "Books-module--book-image--a7efe";
export var books = "Books-module--books--21966";
export var imagelink = "Books-module--imagelink--81949";
export var prompt = "Books-module--prompt--bf9c1";